import { z } from 'zod';
import { AgentRunStatusSchema, AgentTaskSchema, EngagementLeadResultSchema, } from '../domain/agent-run.js';
import { IdSchema, IsoDateTimeSchema, OrgIdSchema, UserIdSchema } from './common.js';
/**
 * A request for the Engagement Lead to read an engagement and produce a proposal.
 *
 * The agent proposes; the backend decides. A run can never move a stage or approve anything —
 * its tools are read-only, and its output is advice attached to the engagement (§1).
 */
export const AgentRunSchema = z.object({
    id: IdSchema,
    orgId: OrgIdSchema,
    engagementId: IdSchema,
    task: AgentTaskSchema,
    status: AgentRunStatusSchema,
    requestedByUserId: UserIdSchema,
    requestedAt: IsoDateTimeSchema,
    updatedAt: IsoDateTimeSchema.optional(),
    /** Present only once the run has succeeded. */
    result: EngagementLeadResultSchema.nullish(),
    /** A message, never a payload — target content is untrusted and stays out of responses (§4). */
    error: z.string().nullish(),
});
/** POST /v1/engagements/{id}/agent-runs */
export const CreateAgentRunRequestSchema = z.strictObject({ task: AgentTaskSchema });
export const ListAgentRunsResponseSchema = z.object({ items: z.array(AgentRunSchema) });
//# sourceMappingURL=agent-run.js.map